import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

interface GetAdminInvestmentDetailsHookType {
  uuid?: string | null;
  enabled?: boolean;
}

export default function useGetAdminInvestmentDetails({
  uuid,
  enabled = true,
}: GetAdminInvestmentDetailsHookType) {
  return useQuery({
    queryKey: ["investments/admin/details", uuid],
    queryFn: async () => {
      return axiosInstance
        .get(`/investments/admin/${uuid}/details`)
        .then((res) => res.data);
    },
    retry: false,
    enabled: enabled && !!uuid,
    staleTime: 1000 * 15,
  });
}
